module.exports = __webpack_public_path__ + "img/new_champ.fe6a6694.jpeg";